module.exports = __webpack_public_path__ + "img/9788993690767.38d5bc08.jpg";